const PaymentMethods: any = {
  MONTHLY: 'monthly',
  FIRST_BILL: 'FIRST_BILL',
  PAY_NOW: 'FULL_PRICE',
  INSTALLMENT_OFFER_36: 'CREDIT_PRICE36',
  INSTALLMENT_OFFER_24: 'CREDIT_PRICE24',
  INSTALLMENT_OFFER_12: 'CREDIT_PRICE12',
  INSTALLMENT_OFFER_6: 'CREDIT_PRICE6',
  TOTAL: 'total',
};

export default PaymentMethods;
